/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Factory } from './factory';
import { StandardEntity } from '../../standard-entity';

export class ObjectFactory implements Factory<StandardEntity> {
  public api: string;
  public idField: string;
  public labelField: string[];
  public displayId: boolean;
  public displayLabel: boolean;
  public group: string;
  constructor(
    api: string,
    idField?: string,
    labelField?: string[],
    displayId = true,
    displayLabel = true,
  ) {
    this.api = api;
    this.idField = idField;
    this.labelField = labelField;
    this.displayId = displayId;
    this.displayLabel = displayLabel;
  }

  build(o: any): any {
    const labelField =
      this.labelField && this.labelField.length > 0 ? this.labelField[0] : null;
    const entity = new StandardEntity(
      o[this.idField],
      labelField ? o[labelField] : o.label,
      this.getDisplay(),
    );
    for (const prop in o) {
      if (entity[prop] === undefined) {
        entity[prop] = o[prop];
      }
    }
    return entity;
  }

  getApi(): string {
    return this.api;
  }

  private getDisplay(): 'full' | 'id' | 'label' {
    if (this.displayId && this.displayLabel) {
      return 'full';
    } else if (this.displayId) {
      return 'id';
    } else if (this.displayLabel) {
      return 'label';
    }
    return 'full';
  }
}
